; (function ($, window, document, undefined) {

    var name = 'customWizard';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customWizard.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            this.goToStep(this.options.step);
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$next = this.$element.find('[data-event="next"]');
            this.$previous = this.$element.find('[data-event="previous"]');
            this.$progress = this.$element.find('.custom-progress');
            this.$steps = this.$element.find('.step');
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('click', '[data-event="next"]', function () {
                plugin.nextStep();
            });

            plugin.$element.on('click', '[data-event="previous"]', function () {
                plugin.previousStep();
            });

            plugin.$element.on('click', '[data-event="skip"]', function () {
                plugin.skipToStep($(this).data('skip'));
            });
        },

        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        validateStep: function (step, data) {
            return $.ajax({
                type: 'POST',
                context: this,
                url: this.options.validationRoute,
                cache: false,
                data: {
                    'step': step,
                    'data': data,
                }, beforeSend: function () {
                }
            });
        },

        goToStep: function (step) {
            this.$element.trigger('load.wizard.step', [this, this.options.step]);

            this.options.step = step < 0 ? this.$steps.length + step : step;
            var progress = this.options.step / this.$steps.length,
                target = this.$steps.filter('[data-step="' + this.options.step + '"]');

            this.$progress.find('li').removeClass('active validated');
            this.$progress.find('li').filter((index, element) => $(element).data('step') < this.options.step).addClass('validated');
            this.$progress.find('li').filter((index, element) => $(element).data('step') == this.options.step).addClass('active');
            this.$next.html(this.options.step == this.$steps.length - 1 ? 'Submit' : 'Next');
            this.$previous.toggle(progress > 0);
            this.$steps.hide();
            target.show();
            $.scrollTo(0);

            this.$element.trigger('loaded.wizard.step', [this, this.options.step]);

            return this;
        },

        skipToStep: function (step) {
            this.$element.trigger('skip.wizard.step', [this, this.options.step]);

            this.options.skippedFrom = this.options.step;
            this.goToStep(step);

            this.$element.trigger('skipped.wizard.step', [this, this.options.step]);

            return this;
        },

        nextStep: function () {
            this.$element.trigger('validate.wizard.step', [this, this.options.step]);

            this.validateStep(this.options.step, this.generateFormData(this.options.step)).then(() => {
                if (this.options.step == this.$steps.length - 1) {
                    this.$element.trigger('complete.wizard.step', [this, this.options.step]);
                    return;
                }

                this.goToStep(++this.options.step);
            }, (e) => {
                $.handleError(e, () => {
                    $.focusOnError(e);
                });
            });

            this.$element.trigger('validated.wizard.step', [this, this.options.step]);

            return this;
        },

        previousStep: function () {
            this.goToStep(this.options.skippedFrom < 0 ? --this.options.step : this.options.step = this.options.skippedFrom);
            this.options.skippedFrom = -1;

            return this;
        },

        generateFormData: function (stepIndex = null) {
            var output = this.$steps.map((index, step) => $.getInputValues($(step), this.options.specialSelectors.concat(['input', 'select', 'textarea']).join())).toArray();
            return stepIndex == null ? output : output[stepIndex];
        },
    });

    $.fn.customWizard = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customWizard.defaults = {
        skippedFrom: -1,
        specialSelectors: [],
        step: 0,
        validationRoute: '/wizard/validate',
    };
})(jQuery, window, document);
